import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { TextContext } from "../Text/TextContext.mjs";
import { HeadingContext } from "../Heading/HeadingContext.mjs";
import { resolveResponsiveRangeProps } from "../../utils/resolveResponsiveRangeProps.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { hiddenOnPrint } from "./Hidden.css.mjs";
import { optimizeResponsiveArray } from "../../utils/optimizeResponsiveArray.mjs";
import dedent from "dedent";
const Hidden = ({
  children,
  component,
  above,
  below,
  screen,
  print,
  inline: inlineProp,
  data,
  ...restProps
}) => {
  if (process.env.NODE_ENV === "development") {
    if (typeof screen !== "undefined") {
      console.warn(
        dedent`
        The "screen" prop is deprecated and will be removed in a future release.
        For content designed to improve the screen reader experience, please use use the <HiddenVisually> component instead.
        Alternatively, for content designed to be hidden unconditionally, remove the "screen" prop.`
      );
    }
  }
  const inText = Boolean(useContext(TextContext));
  const inHeading = Boolean(useContext(HeadingContext));
  const hiddenOnScreen = Boolean(screen);
  const hiddenOnPrint$1 = Boolean(print);
  const hiddenAlways = hiddenOnScreen || !above && !below && !print;
  const [hiddenOnMobile, hiddenOnTablet, hiddenOnDesktop, hiddenOnWide] = resolveResponsiveRangeProps({ above, below });
  const inline = inlineProp ?? (inText || inHeading);
  const display = inline ? "inline" : "block";
  return /* @__PURE__ */ jsx(
    Box,
    {
      display: hiddenAlways ? "none" : optimizeResponsiveArray([
        hiddenOnMobile ? "none" : display,
        hiddenOnTablet ? "none" : display,
        hiddenOnDesktop ? "none" : display,
        hiddenOnWide ? "none" : display
      ]),
      className: hiddenOnPrint$1 ? hiddenOnPrint : void 0,
      component: component || (inline ? "span" : "div"),
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children
    }
  );
};
export {
  Hidden
};
